<template>
  <div class="tools-box">
    <div class="tool-menu">
      <div class="menu-list">
        <div class="menu-item" :class="{isActive: menuActive === '0'}" @click="choseMenu('0')">
          <img :src="ossPath + (menuActive === '0' ? '/pages/home/icon_product_name_active.png' : '/pages/home/icon_product_name_new.png')" alt="" />
          <p>品名附加费试算</p>
        </div>
        <div class="menu-item" :class="{isActive: menuActive === '1'}" @click="choseMenu('1')">
          <img :src="ossPath + (menuActive === '1' ? '/pages/home/icon_distance_active.png' : '/pages/home/icon_distance_new.png')" alt="" />
          <p>卡派距离试算</p>
        </div>
        <div class="menu-item" :class="{isActive: menuActive === '2'}" @click="choseMenu('2')">
          <img :src="ossPath + (menuActive === '2' ? '/pages/home/icon_favorites_active.png' : '/pages/home/icon_favorites_new.png')" alt="" />
          <p>产品收藏</p>
        </div>
      </div>

      <div class="hide-button" @click="$emit('hiddenTools')">
        <div class="hide-icon">
          <img src="../../static/images/shou.png" alt />
        </div>
        <p>收起小工具</p>
      </div>
    </div>
    <div class="tool-main" :class="{isShow: menuActive} ">
      <goods-trail v-if="menuActive === '0'" @cancelChose="menuActive = null"></goods-trail>
      <distance-trail v-else-if="menuActive === '1'" @cancelChose="menuActive = null"></distance-trail>
      <favorites v-else-if="menuActive === '2'" @cancelChose="menuActive = null"></favorites>
    </div>
  </div>
</template>

<script>
import goodsTrail from './goodsTrail'
import distanceTrail from './distanceTrail'
import favorites from './favorites'
export default {
  name: 'toolBar',
  components: {
    goodsTrail,
    distanceTrail,
    favorites
  },
  data() {
    return {
      menuActive: null
    }
  },
  methods: {
    choseMenu(val) {
      this.menuActive = val
    }
  }
}
</script>

<style lang="scss" scoped>
.tools-box {
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  display: flex;
  background: #ffffff;
  border-radius: 20px 0px 0px 20px;
  box-shadow: 0px 0px 24px 0px rgba(47,47,47,0.06);
  z-index: 9;
}
.tool-menu {
  padding: 20px 6px;
  text-align: center;
  display: flex;
  flex-direction: column;
  .menu-list {
    padding-top: 206px;
    display: flex;
    flex-direction: column;
    row-gap: 24px;
    .menu-item {
      max-width: 60px;
      padding: 20px 9px;
      border-radius: 10px;
      cursor: pointer;
      transition: all .3s ease-in;
      &.isActive {
        background: #FF4D01;
        color: #FFFFFF;
      }
    }
  }
}
.tool-main {
  position: relative;
  width: 360px;
  height: inherit;
  display: none;
  background: #F4F4F4;
  &.isShow {
    display: block;
  }
}
.hide-button {
  position: absolute;
  bottom: 20px;
  left: 15px;
  cursor: pointer;
  &:hover {
    color: #FF4D01
  }
  .hide-icon {
    margin-bottom: 10px;
    display: inline-block;
    width: 45px;
    height: 45px;
    background: #FFFFFF;
    box-shadow: 0px 0px 7px 0px rgba(47,47,47,0.17);
    border-radius: 50%;
    img{
      margin-top: 12px;
      width: 22px;
      height: 22px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// common/toolBar/index.vue